/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One numeric column per group, with an optional header row of group names that label the rows from top to bottom.`)
};

const es_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna numérica por grupo, con una fila de encabezado opcional con los nombres de los grupos que etiquetan las filas de arriba hacia abajo.`)
};

const de_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine numerische Spalte pro Gruppe, mit einer optionalen Kopfzeile mit Gruppennamen, die die Reihen von oben nach unten beschriften.`)
};

const nl_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén numerieke kolom per groep, met een optionele koprij van groepsnamen die de rijen van boven naar beneden labelen.`)
};

const fr_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne numérique par groupe, avec une ligne d'en-tête facultative de noms de groupes qui étiquette les lignes de haut en bas.`)
};

const it_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna numerica per gruppo, con una riga di intestazione facoltativa con i nomi dei gruppi che etichettano le righe dall'alto verso il basso.`)
};

const pt_br2_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica por grupo, com uma linha de cabeçalho opcional com os nomes dos grupos que rotulam as linhas de cima para baixo.`)
};

const pt_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica por grupo, com uma linha de cabeçalho opcional com os nomes dos grupos que rotulam as linhas de cima para baixo.`)
};

const ja_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループごとに1つの数値列で、上から下への各行を示すグループ名のヘッダー行を任意で付けられます。`)
};

const zh_ridge_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组一列数值数据，可选带有组名的表头行，用于从上到下为各行加标签。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_faq_a4", locale)
	if (locale === "en") return en_ridge_faq_a4(inputs)
	if (locale === "es") return es_ridge_faq_a4(inputs)
	if (locale === "de") return de_ridge_faq_a4(inputs)
	if (locale === "nl") return nl_ridge_faq_a4(inputs)
	if (locale === "fr") return fr_ridge_faq_a4(inputs)
	if (locale === "it") return it_ridge_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_faq_a4(inputs)
	if (locale === "pt") return pt_ridge_faq_a4(inputs)
	if (locale === "ja") return ja_ridge_faq_a4(inputs)
	return zh_ridge_faq_a4(inputs)
};